<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Pengaturan</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Profile POS Mobile Counter</div>
					</div>
					<div class="col-6 col-md-3 pl-0 pr-0 pt-2 pt-md-0 mt-auto mb-auto d-flex justify-content-end">
						<button class="col-12 col-lg-10 btn btn-white d-flex justify-content-center" @click="addAdmin('add')">
							<span class="font-size-10 font-size-sm-8"><i class="fas fa-plus"></i></span>
							<div class="pl-2 font-size-11 font-size-sm-9 text-uppercase font-weight-bold">tambah admin</div>
						</button>
					</div>
				</div>
			</div>
			<div class="col-12 pl-0 pr-0 pt-3">
				<div class="row" v-show="Object.keys(profile).length == 0">
					<carousel ref="carousel" id="owl-menu" class="col-12 pr-0" :responsive="{0:{items:1},600:{items:2},1000:{items:4}}" :margin="0" :autoplay="false" :nav="false" :loop="false" :dots="true">
						<div class="col-12 pl-0">
							<div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
								<div class="col-12 bg-gray-2 pt-2 pb-2 font-size-12">
									<vcl :width='400' :height='40'>
										<rect x="120" y="5" rx="3" ry="3" width="150" height="30" />
									</vcl>
								</div>
								<div class="col-12 text-center pt-2">
									<vcl :width='400' :height='640'>
										<rect x="100" y="3" rx="90" ry="90" width="170" height="170" />
										<rect x="100" y="198" rx="2" ry="2" width="170" height="27" />
										<rect x="115" y="240" rx="2" ry="2" width="140" height="20" />
										<rect x="15" y="290" rx="2" ry="2" width="160" height="25" />
										<rect x="15" y="326" rx="2" ry="2" width="120" height="20" />
										<rect x="15" y="358" rx="0" ry="0" width="390" height="2" />
										<rect x="15" y="380" rx="2" ry="2" width="90" height="25" />
										<rect x="15" y="416" rx="2" ry="2" width="190" height="20" />
										<rect x="15" y="448" rx="0" ry="0" width="390" height="2" />
										<rect x="15" y="470" rx="2" ry="2" width="160" height="25" />
										<rect x="15" y="506" rx="2" ry="2" width="190" height="20" />
										<rect x="15" y="538" rx="0" ry="0" width="390" height="2" />
										<rect x="15" y="560" rx="2" ry="2" width="190" height="25" />
										<rect x="15" y="596" rx="2" ry="2" width="160" height="20" />
									</vcl>
								</div>
							</div>
						</div>
					</carousel>
				</div>
				<div class="row" v-if="Object.keys(profile).length > 0">
					<carousel ref="carousel" id="owl-menu" class="col-12 pr-0" :responsive="{0:{items:1},600:{items:2},800:{items:3},1000:{items:4}}" :margin="0" :autoplay="false" :nav="false" :loop="false" :dots="true">
						<div class="col-12 pl-0" v-for="(value, index) in profile" :key="index">
							<div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
								<div class="col-12 pt-2 pb-2 font-size-12 color-white text-center d-flex justify-content-between" :class="value.type == 'Akun Utama' ? 'bg-blue' : 'bg-gray-2' ">
									<div class="col-12 d-flex justify-content-center" >{{value.type}}</div>
									<div class="ml-n3 cursor-pointer z-index-1" @click="editAdmin(value, 'edit')"><i class="fas fa-edit"></i></div>
								</div>
								<div class="col-12 text-center pt-2">
									<img :src="value.image" class="img-profile ml-auto mr-auto">
									<div class="pt-2 font-size-13 font-weight-bold">{{value.name}}</div>
									<div class="pt-1 font-size-9 color-blue font-weight-bold">Mobile Counter</div>
								</div>
								<div class="col-12 pl-4 pr-4 pt-3">
									<div class="col-12 pl-0 pr-0">
										<div class="font-size-10 color-gray-2 text-uppercase">kode stockist</div>
										<div class="font-size-11">{{value.username}}</div>
										<div class="col-12 pt-1 border-bottom"></div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-3">
										<div class="font-size-10 color-gray-2 text-uppercase">email</div>
										<div class="font-size-11">{{value.email}}</div>
										<div class="col-12 pt-1 border-bottom"></div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-3">
										<div class="font-size-10 color-gray-2 text-uppercase">nomor handphone</div>
										<div class="font-size-11">{{value.mobilephone}}</div>
										<div class="font-size-11" v-if="value.type == 'Akun Utama' && value.mobilephone2">{{value.mobilephone2}}</div>
										<div class="col-12 pt-1 border-bottom"></div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-3 pb-3">
										<div class="font-size-10 color-gray-2 text-uppercase">tanggal bergabung</div>
										<div class="font-size-11">{{value.join | toTanggal }}</div>
									</div>
								</div>
							</div>
						</div>
					</carousel>
				</div>
			</div>
		</div>
		<i-modal ref="modalAddAdmin" class="modal-big">
			<template v-slot:header>
				<div class="modal-header no-border p-3">
					<div class="modal-title font-size-12 font-weight-bold"></div>
					<button class="btn no-box-focus"><span @click="hideAddAdmin" class="close-modal ml-2 color-red"><i class="fas fa-times"></i></span></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 pl-0 pr-0 pl-md-3 pr-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
						<div class="col-12 col-md-5 pl-0 pr-0 pr-md-3 pb-4 border-bottom border-md-right">
							<div class="font-size-12 color-blue text-center text-uppercase font-weight-bold" v-if="status == 'add'">tambah admin</div>
							<div class="font-size-12 color-blue text-center text-uppercase font-weight-bold" v-else>update admin</div>
							<div v-if="status == 'edit'" class="col-12 pt-1 text-center"><img :src="image" class="img-add-profile ml-auto mr-auto"></div>
							<div v-if="status == 'edit'" class="col-12 text-center pt-2">
								<div class="upload-btn-wrapper">
									<button class="btn-upload">Upload Gambar</button>
									<input @focus="() => !responUpload == ''" type="file" name="myfile" ref="inputFile" class="upload text-white" v-on:change="handleFileUpload($event)">
									<div class="font-size-8 pt-1 color-red" v-if="!responUpload == ''">{{responUpload}}</div>
								</div>
							</div>
							<div class="pt-2 font-size-11 color-gray-2 text-center text-uppercase font-weight-bold">detail pribadi</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-2">
								<input class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nama" v-model="params.name" @click="getNama" @focus="() => konfirmResponse.name = ''" :disabled="type == 'Akun Utama'">
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.name">{{konfirmResponse.name}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-3" v-if="status == 'add'">
								<input maxlength="20" @focus="() => konfirmResponse.password = ''" class="form-control box-blue rounded-cus font-size-10" type="password" placeholder="Password" v-model="params.password" @click="getPassword">
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.password">{{konfirmResponse.password}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-3">
								<input @focus="() => konfirmResponse.email = ''" class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Email" v-model="params.email" @click="getEmail" :disabled="type == 'Akun Utama'">
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.email">{{konfirmResponse.email}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-3">
								<input @focus="() => konfirmResponse.mobilephone = ''"  class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nomor Handphone" v-model="params.mobilephone" @click="getMobilephone" :disabled="type == 'Akun Utama'">
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.mobilephone">{{konfirmResponse.mobilephone}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-3" v-if="type == 'Akun Utama'">
								<input @focus="() => konfirmResponse.mobilephone2 = ''"  class="form-control box-blue rounded-cus font-size-10" type="text" placeholder="Nomor Handphone (optional)" v-model="params.mobilephone2" @click="() => { konfirmResponse.mobilephone2 = '' }" :disabled="type == 'Akun Utama'">
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.mobilephone2">{{konfirmResponse.mobilephone2}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 pr-md-3 pt-3" v-if="type == 'Akun Kasir' || status == 'add'">
								<datetime @close="checkDate" class="theme-purple" :max-datetime="maxdate"  v-model="params.birthdate" input-class="col-12 form-control border color-black box-purple rounded-cus font-size-10" placeholder="Tanggal Lahir"></datetime>
								<div class="font-size-8 pt-1 color-red" v-if="konfirmResponse.birthdate">{{konfirmResponse.birthdate}}</div>
							</div>
						</div>
						<div class="col-12 col-md-7 pl-0 pl-md-3 pr-0 pb-4 pt-3 pt-md-0 border-bottom">
							<div class="pl-md-3 font-size-12 color-blue text-uppercase font-weight-bold">hak akses menu untuk admin</div>
							<div class="col-12 d-flex pt-3 pl-0 pr-0 pl-md-3 pr-md-3">
								<div class="col-6 pl-0">
									<div class="font-size-11 font-weight-bold">Inventory</div>
									<!-- <div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="stock-product" value="stock-product" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="stock-product">Menu Produk</label>
									</div> -->
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="stock-serial" value="stock-serial" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="stock-serial">Stok Serial</label>
									</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="stock-history" value="stock-history" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="stock-history">Riwayat Stok</label>
									</div>
								</div>
								<div class="col-6 pl-0 pr-0 pr-md-3">
									<div class="font-size-11 font-weight-bold">Transaksi</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="transaction" value="transaction" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="transaction">Transaksi Penjualan</label>
									</div>
									<!-- <div class="pt-1 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="transaction" value="transaction" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="transaction">Mitra Baru Milagros</label>
									</div> -->
								</div>
							</div>
							<div class="col-12 d-flex pt-3 pl-0 pr-0 pl-md-3 pr-md-3">
								<div class="col-6 pl-0">
									<div class="font-size-11 font-weight-bold">Pendaftaran</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="register" value="register" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="register">Menu Pendaftaran</label>
									</div>
								</div>
								<div class="col-6 pl-0 pr-0">
									<div class="font-size-11 font-weight-bold">Laporan Penjualan</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="sales-report" value="sales-report" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="sales-report">Menu Laporan Penjualan</label>
									</div>
									<div class="pt-1 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="new-mitra-report" value="new-mitra-report" v-model="hak">
										<label class="custom-control-label font-size-9 pt-1" for="new-mitra-report">Menu Laporan Mitra Baru</label>
									</div>
								</div>
							</div>
							<div class="col-12 d-flex pt-3 pl-0 pr-0 pl-md-3 pr-md-3">
								<div class="col-6 pl-0">
									<div class="font-size-11 font-weight-bold">Penerimaan Barang</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="receipt" value="receipt" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="receipt">Penerimaan Barang</label>
									</div>
								</div>
								<div class="col-6 pl-0">
									<div class="font-size-11 font-weight-bold">Pengaturan</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="profile" value="profile" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="profile">Menu Profile</label>
									</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="setting-edc" value="setting-edc" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="setting-edc">Pembayaran EDC</label>
									</div>
									<div class="pt-2 custom-control custom-checkbox">
										<input type="checkbox" :disabled="userData.stockist_type != 'utama' || type == 'Akun Utama'" class="custom-control-input" id="setting-address" value="setting-address" v-model = "hak">
										<label class="custom-control-label font-size-9 pt-1" for="setting-address">Pengaturan Alamat</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 text-center pt-4 pb-3 pl-0 pr-0">
						<button v-if="status == 'edit' && type == 'Akun Kasir' && userData.stockist_type == 'utama'" class="col-6 col-md-3 pt-2 pb-2 btn btn-outline-danger mr-3" @click="hapus">
							<div class="font-size-11 text-uppercase">hapus admin</div>
						</button>
						<button class="col-5 col-md-3 pt-2 pb-2 btn btn-blue" @click="simpan">
							<div class="font-size-11 text-uppercase">simpan</div>
						</button>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal"></div>
			</template>
		</i-modal>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-6 col-md-5">
							<img class="img-fluid" src="/assets/modal/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 mt-auto mb-auto pt-3 pt-md-0 text-center text-md-left">
							<div class="font-size-11 font-weight-bold">Konfirmasi Hapus</div>
							<div class="font-size-10 pt-1 pt-md-3">Apakah Anda yakin ingin menghapus Data ini?</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-md-end">
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalAlert">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="hapusAdmin">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Yakin</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import IModal from '@/components/IModal.vue';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	components: {
		carousel, IModal,
	},
	data() {
		return {
			image: '',
			type: '',
			username: '',
			hak:[],
			params: {
				name: '',
				email: '',
				mobilephone: '',
				mobilephone2: '',
				birthdate: '',
				password: '',
				privilege :'',
				is_active: 1
			}
		}
	},
	methods: {
		...mapActions('profileList', ['getProfile', 'addProfile', 'updateProfileUtama', 'updateProfileKasir', 'deleteProfile', 'uploadImageUtama', 'uploadImageKasir']),
		...mapMutations('profileList', ['listProfile']),
		getNama() {
			this.konfirmResponse.name = ''
		},
		getEmail() {
			this.konfirmResponse.email = ''
		},
		getPassword() {
			this.konfirmResponse.password = ''
		},
		getMobilephone() {
			this.konfirmResponse.mobilephone = ''
		},
		checkDate(){
			if (this.params.birthdate) {
				this.konfirmResponse.birthdate = ''
			} else {
				this.konfirmResponse.birthdate = 'Data tidak boleh kosong'
			}
		},
		addAdmin(note) {
			this.status = note
			this.$refs.modalAddAdmin.modalShow()
		},
		hapus() {
			this.$refs.modalAlert.modalShow()
		},
		editAdmin(value, note) {
			this.type = value.type
			this.status = note
			this.image = value.image
			this.params.name = value.name
			this.params.email = value.email
			this.params.password = value.password
			this.params.mobilephone = value.mobilephone
			this.params.mobilephone2 = value.mobilephone2
			if(value.birtdate) {
				this.params.birthdate = new Date(value.birtdate).toISOString()
			} else {
				this.params.birthdate = ''
			}
			this.params.username = value.username
			this.username = value.username
			if(value.privilege) {
				this.hak = value.privilege
			} else {
				this.hak = []
			}
			this.$refs.modalAddAdmin.modalShow()

		},
		hideAddAdmin() {
			this.$refs.modalAddAdmin.modalHide()
			this.resetData()
		},
		hideModalAlert() {
			this.$refs.modalAlert.modalHide()
			this.username = ''
		},
		simpan() {
			this.listProfile([])
			this.params.privilege = JSON.stringify(this.hak)
			if(this.status == 'add') {
				this.addProfile(this.params).then( () => {
					this.getProfile()
					if(this.responSukses == 200) {
						this.hidemodal()
					} else {
						this.$refs.modalAddAdmin.modalShow()
					}
				})
			}  else {
				if(this.type == 'Akun Utama') {
					this.updateProfileUtama(this.params).then( () => {
						this.getProfile()
						if(this.responSukses == 200) {
							this.hidemodal()
						} else {
							this.$refs.modalAddAdmin.modalShow()
						}
					})
				} else {
					this.updateProfileKasir(this.params).then( () => {
						this.getProfile()
						if(this.responSukses == 200) {
							this.hidemodal()
						} else {
							this.$refs.modalAddAdmin.modalShow()
						}
					})
				}
			}
		},
		hapusAdmin() {
			this.deleteProfile({username : this.username}).then( () => {
				if(this.responSukses == 200) {
					this.hidemodal()
				}
			})
		},
		hidemodal(){
			this.$refs.modalAlert.modalHide()
			this.$refs.modalAddAdmin.modalHide()
			this.resetData()
		},
		resetData() {
			this.username = ''
			this.params.name = ''
			this.params.email = ''
			this.params.password = ''
			this.params.mobilephone = ''
			this.params.mobilephone2 = ''
			this.params.birthdate = ''
			this.hak = []
			this.status = ''
			this.type = ''
			this.image = ''
			this.konfirmResponse.name = ''
			this.konfirmResponse.password = ''
			this.konfirmResponse.email = ''
			this.konfirmResponse.mobilephone = ''
			this.konfirmResponse.mobilephone2 = ''
			this.konfirmResponse.birthdate = ''
		},
		handleFileUpload(event) {
			this.formData = new FormData();
			this.formData.append('code', this.params.username);
			this.formData.append('image', event.target.files[0]);
			
			var files = event.target.files || event.dataTransfer.files;

			if (!files.length)
				return;

			this.createImage(files[0]);
		},
		createImage(file) {
			var reader = new FileReader();
			var vm = this;

			reader.onload = (e) => {
				vm.image = e.target.result;
			};
			reader.readAsDataURL(file);

			if(this.formData) {
				if(this.type == "Akun Utama") {
					this.uploadImageUtama(this.formData)
					if(this.responUpload =='')
					{
						this.image = ''
					}
				} else {
					this.uploadImageKasir(this.formData)
					if(this.responUpload =='')
					{
						this.image = ''
					}
				}
			}
		},
	},
	computed: {
		...mapState('profileList', ['profile', 'konfirmResponse', 'responSukses', 'responUpload']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),
		maxdate(){
			var date = new Date(new Date().setFullYear(new Date().getFullYear())).toISOString()
			return date;
		},
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Profile');
		this.getProfile()
	}
};
</script>
